import { SegmentAddon } from '@app/react/components/calendar/newReservation/NewReservationTypes';

export const INITIAL_SEGMENTS_ADDON: SegmentAddon = { quantity: 0 };
export const INITIAL_SEGMENTS_ADDONS: SegmentAddon[] = [INITIAL_SEGMENTS_ADDON];
export const SEGMENTS_ADDONS = 'segmentsAddons';

export const SEGMENT_IDS = 'segmentIds';
